export const buttonStyle = {
  marginRight: "10px",
  marginBottom: "10px"
};

export const fullWidthStyle = {
  width: "100%"
};

export const noDisplayStyle = {
  display: "none"
};

export const whiteTextStyle = {
  color: "white"
};

export const tableCellStyle = {
  ...whiteTextStyle,
  fontSize: "1.1em"
};

export const tableTitleStyle = {
  ...tableCellStyle,
  fontSize: "1.2em"
}

export const titleStyle = {
  ...whiteTextStyle,
  marginTop: 0,
  marginBottom: "20px"
};

export const cardGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
  gap: "16px",
  width: "100%"
};

export const cardGridPaginationStyle = {
  marginTop: "16px",
  width: "100%",
  display: "flex",
  justifyContent: "flex-end"
};

export function centeredPadding(maxHalfWidthPx: number, minGutterPx: number = 16): string {
  return `max(${minGutterPx}px, calc(50% - ${maxHalfWidthPx}px))`;
}